import React from 'react';
import { ProviderDocument, ProviderDocumentType } from '@uplift/api';
import { CollaborativeAgreementSignedListItem } from './CollaborativeAgreementSignedListItem';
import { CollaborativeAgreementUnsignedListItem } from './CollaborativeAgreementUnsignedListItem';
import { CollaborativeAgreementCounterSignatureRequiredListItem } from './CollaborativeAgreementCounterSignatureRequiredListItem';
import { CollaborativeAgreementCounterSignedListItem } from './CollaborativeAgreementCounterSignedListItem';
import { CollaborativeAgreementExpiredListItem } from './CollaborativeAgreementExpiredListItem';
import { CollaborativeAgreementExpiringListItem } from './CollaborativeAgreementExpiringListItem';
import { StateExhibitListItem } from './StateExhibitListItem';
import { UploadedProviderDocumentListItem } from './UploadedProviderDocumentListItem';


export const DocumentListItem: React.VFC<{
  document: ProviderDocument;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  switch (document.type) {
    case ProviderDocumentType.collaborativeAgreementUnsigned:
      return (
        <CollaborativeAgreementUnsignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreement:
      return (
        <CollaborativeAgreementSignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSignatureRequired:
      return (
        <CollaborativeAgreementCounterSignatureRequiredListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSigned:
      return (
        <CollaborativeAgreementCounterSignedListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementExpired:
      return (
        <CollaborativeAgreementExpiredListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.collaborativeAgreementExpiring:
      return (
        <CollaborativeAgreementExpiringListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.stateExhibit:
      return (
        <StateExhibitListItem
          document={document.document}
          onClick={onClick}
          selected={selected}
        />
      );
    case ProviderDocumentType.uploadedProviderDocument:
      return (
        <UploadedProviderDocumentListItem
          document={document.document}
          datetime={document.datetime}
          onClick={onClick}
          selected={selected}
        />
      );
    default:
      return null;
  }
};
